<template>
  <section>
    <p class="is-size-5">
      <strong>Tournament Pipeline</strong> ({{
        tournament.automate ? "auto 🤖" : "manual"
      }})
    </p>

    <div class="is-flex is-justify-content-space-between is-align-items-center">
      <ButtonTooltip
        :tooltip="
          tournament.automate ? 'Run steps manually' : 'Automatically run steps'
        "
        :label="tournament.automate ? 'AUTO OFF' : 'AUTO ON'"
        :icon-left="tournament.automate ? 'hand-spock' : 'robot'"
        :type="tournament.automate ? 'is-danger' : 'is-success'"
        :disabled="
          !tournament.automate &&
          tournament.currentRound > tournament.totalRounds
        "
        @click="toggleAutomate"
      />

      <ButtonTooltip
        tooltip="Sync round time"
        label="Sync"
        icon-left="sync"
        type="is-info"
        @click="syncRoundTime"
        :disabled="
          !steps.length ||
          !nextStep ||
          tournament.currentRound > tournament.totalRounds
        "
      />

      <ButtonTooltip
        tooltip="Show/Hide steps"
        :icon-left="showSteps ? 'eye-slash' : 'eye'"
        type="is-warning"
        @click="$emit('onToggleSteps')"
        :disabled="!steps.length"
      />
    </div>
  </section>
</template>

<script>
import ButtonTooltip from "@/components/ui/ButtonTooltip.vue";
import { firestore } from "@/services/firebase";
import { syncSteps } from "vue-chess-shared/tournament/utils/pipeline-helper";

export default {
  components: {
    ButtonTooltip,
  },

  name: "PipelineControl",

  props: ["tournament", "rounds", "steps", "showSteps"],

  computed: {
    tournamentRef() {
      if (!this.tournament) return null;
      return firestore.collection("tournaments").doc(this.tournament.id);
    },

    stepsRef() {
      return this.tournamentRef.collection("steps");
    },

    nextStep() {
      if (!this.steps || !this.steps.length) return null;
      return this.steps.find((step) => step.status === "scheduled");
    },
  },

  methods: {
    toggleAutomate() {
      if (this.tournament.currentRound > this.tournament.totalRounds) {
        this.tournamentRef.update({ automate: false });
        this.$buefy.toast.open({
          message: "Tournament has ended, can't turn on automation",
          type: "is-warning",
        });
        return;
      }
      // if there is no rounds, show a toast message
      if (!this.rounds || !this.rounds.length) {
        this.tournamentRef.update({ automate: false });
        this.$buefy.toast.open({
          message: "Please schedule rounds before turning on automation",
          type: "is-warning",
        });
        return;
      }
      this.$buefy.toast.open({
        message: `Automation turned ${this.tournament.automate ? "OFF" : "ON"}`,
        type: "is-info",
      });
      this.tournamentRef.update({ automate: !this.tournament.automate });
    },

    syncRoundTime() {
      if (!this.steps || !this.steps.length) return;
      if (!this.rounds || !this.rounds.length) return;

      const timeUpdates = syncSteps(this.steps, this.tournament, this.rounds);

      const batch = firestore.batch();
      Object.entries(timeUpdates).forEach(([stepIndex, update]) => {
        const step = this.steps.find((s) => s.index.toString() === stepIndex);
        if (step) {
          batch.update(this.stepsRef.doc(step.id), update);
        }
      });
      batch.commit();
    },
  },
};
</script>

<style></style>
